import React from 'react';
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import PageHeader from "../components/PageHeader";
import Footer from "../components/Footer";
import FjjDetails from "../components/zx_FjjDetails";

const FjjDetailsPage = () => {
    return (
        <Layout pageTitle="苏州卫捷 | 分拣设备">
            <NavOne />
            <PageHeader title="分拣设备" />
            <FjjDetails />
            <Footer />
        </Layout>
    );
};

export default FjjDetailsPage;
